export default __webpack_public_path__ + "static/media/trees.a1ed34d6.png";